module.exports = __webpack_public_path__ + "static/media/Graph.0251f8ff.png";